<div class="row">

	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right link"
				(click)="edit(null)"
				*ngIf="project?.isDraft">
				<i
					container="body btn btn-sm btn-primary"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-activitykpis' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<!-- INDICATORE -->
					<ngx-datatable-column
						prop="kpiname"
						[flexGrow]="2"
						[name]="'activitykpi.kpiname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- DESCRIZIONE -->
					<ngx-datatable-column
						prop="description"
						[flexGrow]="2"
						[name]="'activitykpi.description' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- UNITA DI MISURA -->
					<ngx-datatable-column
						prop="unit"
						[flexGrow]="2"
						[name]="'activitykpi.unit' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- VAL. INTERMEDIO MINIMO -->
					<ngx-datatable-column
						prop="intmin"
						[flexGrow]="2"
						[name]="'activitykpi.intmin' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- VAL. INTERMEDIO MASSIMO -->
					<ngx-datatable-column
						prop="intmax"
						[flexGrow]="2"
						[name]="'activitykpi.intmax' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- VAL. FINALE MINIMO -->
					<ngx-datatable-column
						prop="finalmin"
						[flexGrow]="2"
						[name]="'activitykpi.finalmin' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<!-- VAL. FINALE MASSIMO -->
					<ngx-datatable-column
						prop="finalmax"
						[flexGrow]="2"
						[name]="'activitykpi.finalmax' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="edit(row.id)"
									class="link"
									*ngIf="project?.isDraft">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link"
									*ngIf="project?.isDraft">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
